import { SsoMappingRulesBannerState } from '@layout/sso-mapping-rules-banner/store/states/sso-mapping-rules-banner.state';

export const ssoMappingRulesBannerState = [SsoMappingRulesBannerState];
